import { useEffect, useState } from 'react';
import { withRouter } from '../../../common/with-router';
import Table from '../../../components/Table';
import { useLocation, useNavigate } from 'react-router-dom';
import Search from '../../../components/Search';
import Loading from '../../../components/global/loading';
import Pagination from '../../../components/Pagination';
import CrewFilter from "../../../components/CrewFilter";
import {getEntries} from "../../../api/entries";
import {checkRole, qualifiedOptions} from "../../../utils/Helpers";
import {useSelector} from "react-redux";

const BoatTent = (props) => {
	const API_URL = process.env.REACT_APP_API_URL;
	const token = localStorage.getItem('_rrjt');
	const location = useLocation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [entries, setEntries] = useState({});
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		checkedIn: null,
	});
	const [isSearching, setIsSearching] = useState(false);
	const [sortDirection, setSortDirection] = useState('asc');
	const [sortedColumn, setSortedColumn] = useState('id');
	const [canUserExternalSearch, setCanUserExternalSearch] = useState(false);

	const user = useSelector(state => state.user);

	const handleSort = (column) => {
		const newSortDirection = (sortDirection === 'asc' && sortedColumn === column) ? 'desc' : 'asc';
		setSortDirection(newSortDirection);
		setSortedColumn(column);
	};

	useEffect(() => {
		setCanUserExternalSearch(checkRole(user.user.role, ['boat-tent'], false));
	}, [user])

	const getInitialData = async () => {
		try {
			const allFilters = {
				status: [{value:9}],
				qualified_status: [{value:2},{value:3}],
				...filters
			}
			const getEntriesRes = await getEntries(allFilters, page, sortDirection, sortedColumn);
			if (getEntriesRes.data.status === 'success') {
				setEntries(getEntriesRes.data.entries);
				setLoading(false);
			}
		} catch (error) {
			console.log('error', error);
		}
	}

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const hasUrlOptions = Array.from(searchParams.keys()).length > 0;

		if(!hasUrlOptions) {
			getInitialData();
			console.log('!hasUrlOptions')
			return;
		}

		if(filters.checkedIn === null) {
			console.log('null', filters)
			return;
		}
		console.log('end')
		getInitialData();
	}, [page, filters, sortDirection, sortedColumn]);

	const handleFilters = (newFilters) => {
		setFilters(newFilters);
	};

	const handleSearch = (data) => {
		if (!data) {
			getInitialData();
			return;
		}

		setIsSearching(true);
		setPage(1);
		setEntries(data);
	};

	const columns = () => {
		return Object.entries(entries.data).map(([key, value]) => {
			return {
				view: 'admin',
				id: value.id,
				crew_number: value.crew.crew_number,
				crew_name: value.crew.crew_name,
				event_name: value.event.name,
				registration: (value.crew.crew_checked_in) ? 'Yes' : 'No',
				t_q: value.qualification_status ? qualifiedOptions[value.qualification_status]?.label : 'N/A'
			};
		});
	};

	return (
		<div className="container-fluid">
			<div className="row">
			</div>
			<div className="row">
				<div className="col-12 col-md-6">
					<h1>Crew Registrations</h1>
				</div>
				<div className="col-12 col-md-6 mb-3">
					<Search
						handleSearch={handleSearch}
						endpoint="admin/entries/search"
						page={page}
						setIsSearching={setIsSearching}
						placeholder={canUserExternalSearch ? 'Search crew no/crew name' : 'Search ENC Number or ID'}
						setLoading={setLoading}
						externalSearch={canUserExternalSearch}
					/>
				</div>
				<div className="filters-container">
					<div className="col-12">
						<h3>Filters</h3>
					</div>
					<div className="col-12 col-md-12 mb-3">
						<CrewFilter handleFilters={handleFilters} filters={filters} />
					</div>
				</div>
				{loading ?
					<Loading/> :
					<div className="col-12 form-group">
						<div>
							{(entries.data) ?
								<div>
									<Table
										data={columns()}
										visibleColumns={[
											{
												name: 'crew_number',
												sort: 'crew_number'
											},
											{
												name: 'crew_name',
												sort: 'crew_name'
											},
											{
												name: 'event_name',
												sort: 'event_name'
											},
											{
												name: 't_q',
												sort: 'qualification_status'
											},
											{
												name: 'registration',
												sort: 'registration'
											},
										]}
										onSort={handleSort}
										sortedColumn={sortedColumn}
										sortDirection={sortDirection}
										linkColumn="crew_name"
										linkLocation="/admin/boat-tent/edit"
									/>
									<Pagination data={entries} setPage={setPage} />
								</div> : <div className="alert alert-danger">No entries found.</div>
							}
						</div>
					</div>
				}
			</div>
		</div>
	);
}

export default withRouter(BoatTent);
